
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/point-of-interest-list/[destinationSlug]",
      function () {
        return require("private-next-pages/point-of-interest-list/[destinationSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/point-of-interest-list/[destinationSlug]"])
      });
    }
  